import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 内容管理一级
const contentRouter: RouteConfig = {
  path: '/content',
  component: Layout,
  redirect: '/content/content-channel-index',
  meta: {
    title: '内容',
    icon: 'menu-content'
  },
  children: [
    {
      name: 'ContentChannelIndex',
      path: 'content-channel-index',
      component: () => import('@/views/content/content-channel/index.vue'),
      redirect: '/content/content-channel-index/content-channel',
      meta: {
        title: '渠道资源位'
      },
      children: [
        {
          name: 'ContentChannel',
          path: 'content-channel',
          component: () => import('@/views/content/content-channel/content-channel.vue'),
          meta: {
            title: '资源列表'
          }
        },
        {
          name: 'ChannelAddEdit',
          path: 'channel-add-edit',
          component: () => import('@/views/content/content-channel/add-edit.vue'),
          meta: {
            title: '资源位调整',
            showTitle: true
          }
        }
      ]
    },
    {
      name: 'ContentSpecial',
      path: 'content-special',
      component: () => import('@/views/content/content-special/index.vue'),
      redirect: '/content/content-special/content-special-display',
      meta: {
        title: '专题管理'
      },
      children: [
        {
          name: 'ContentSpecialDisplay',
          path: 'content-special-display',
          component: () => import('@/views/content/content-special/special-display.vue'),
          meta: {
            title: '专题展示位'
          }
        },
        {
          name: 'ContentSpecialLib',
          path: 'content-special-lib',
          component: () => import('@/views/content/content-special/special-lib.vue'),
          redirect: '/content/content-special/content-special-lib/content-special-lib-ios',
          meta: {
            title: '专题库'
          },
          children: [
            {
              name: 'ContentSpecialLibIos',
              path: 'content-special-lib-ios',
              component: () => import('@/views/content/content-special/special-lib-ios.vue'),
              meta: {
                title: '专题库IOS'
              }
            },
            {
              name: 'ContentSpecialLibAndroid',
              path: 'content-special-lib-android',
              component: () => import('@/views/content/content-special/special-lib-android.vue'),
              meta: {
                title: '专题库Android'
              }
            }
          ]
        },
        {
          name: 'ContentSpecialAdd',
          path: 'content-special-add',
          component: () => import('@/views/content/content-special/special-add.vue'),
          meta: {
            title: '新增专题',
            showTitle: true
          }
        },
        {
          name: 'ContentSpecialEdit',
          path: 'content-special-edit',
          component: () => import('@/views/content/content-special/special-edit.vue'),
          meta: {
            title: '编辑专题',
            showTitle: true
          }
        },
        {
          name: 'ContentSpecialTranslate',
          path: 'content-special-translate',
          component: () => import('@/views/content/content-special/special-translate.vue'),
          meta: {
            title: '翻译管理',
            showTitle: true
          }
        }
      ]
    },
    {
      name: 'ContentBanner',
      path: 'content-banner',
      component: () => import('@/views/content/content-banner/index.vue'),
      meta: {
        title: '运营 Banner'
      },
      redirect: '/content/content-banner/banner-list',
      children: [
        {
          name: 'BannerList',
          path: 'banner-list',
          component: () => import('@/views/content/content-banner/banner-list.vue'),
          meta: {
            title: '导入/修改banner'
          }
        },
        {
          name: 'BannerAddEdit',
          path: 'banner-add-edit',
          component: () => import('@/views/content/content-banner/banner-add-edit.vue'),
          meta: {
            title: '导入/修改banner'
          }
        }
      ]
    },
    {
      name: 'ContentNews',
      path: 'content-news',
      component: () => import('@/views/content/content-news/index.vue'),
      redirect: '/content/content-news/news-list',
      meta: {
        title: '资讯管理'
      },
      children: [
        {
          name: 'NewsList',
          path: 'news-list',
          component: () => import('@/views/content/content-news/news-list.vue'),
          meta: {
            title: '资讯列表'
          }
        },
        {
          name: 'NewsClassify',
          path: 'news-classify',
          component: () => import('@/views/content/content-news/news-classify.vue'),
          meta: {
            title: '分类管理'
          }
        },
        {
          name: 'NewsTags',
          path: 'news-tags',
          component: () => import('@/views/content/content-news/news-tags.vue'),
          meta: {
            title: 'TAG管理'
          }
        },
        {
          name: 'TagEdit',
          path: 'tag-edit',
          component: () => import('@/views/content/content-news/tag-edit.vue'),
          meta: {
            title: '标签管理'
          }
        },
        {
          name: 'NewsAdd',
          path: 'news-add',
          component: () => import('@/views/content/content-news/news-add.vue'),
          meta: {
            title: '新增资讯',
            showTitle: true
          }
        },
        {
          name: 'NewsEdit',
          path: 'news-edit',
          component: () => import('@/views/content/content-news/news-edit.vue'),
          meta: {
            title: '编辑资讯',
            showTitle: true
          }
        }
      ]
    },
    {
      name: 'ContentNotify',
      path: 'content-notify',
      component: () => import('@/views/content/content-notify/index.vue'),
      redirect: '/content/content-notify/notify-list',
      meta: {
        title: '公告 • 推送'
      },
      children: [
        {
          name: 'NotifyList',
          path: 'notify-list',
          component: () => import('@/views/content/content-notify/notify-list.vue'),
          meta: {
            title: '公告'
          }
        },
        {
          name: 'PushList',
          path: 'push-list',
          component: () => import('@/views/content/content-notify/push-list.vue'),
          meta: {
            title: '消息推送'
          }
        },
        {
          name: 'NoticeEdit',
          path: 'notice-edit',
          component: () => import('@/views/content/content-notify/notice-edit.vue'),
          meta: {
            title: '公告编辑'
          }
        }
      ]
    },
    {
      name: 'SEOM',
      path: 'content-seo',
      component: () => import('@/views/content/content-seo/index.vue'),
      redirect: '/content/content-seo/seo',
      meta: {
        title: 'SEO管理'
      },
      children: [
        {
          name: 'SEO',
          path: 'seo',
          component: () => import('@/views/content/content-seo/seo.vue'),
          meta: {
            title: 'SEO'
          }
        },
        {
          name: 'StandAlone',
          path: 'stand-alone',
          component: () => import('@/views/content/content-seo/stand-alone.vue'),
          meta: {
            title: '独立页'
          }
        }
      ]
    }
  ]
}

export default contentRouter
